import styled from 'styled-components';
import { Icon } from '@libs/uikit/Components';

export const StyledCopyButton = styled(Icon)`
    position: absolute;
    z-index: 1;
    margin: 8px;
    color: grey;
    background-color: #f4f7f2;
    border: 1px solid grey;
    width: 32px;
    height: 32px;
    text-align: center;
    vertical-align: middle;
    font-size: 30px;
    right: 12px;
    opacity: 0.6;

    &:hover {
        opacity: 1;
    }

    &:active {
        opacity: 0.8;
    }
`;
